<h1 mat-dialog-title class="text-dark text-xl">
  {{ data.id ? 'Modifica Azione pratica' : 'Nuova Azione pratica' }}
</h1>
<div mat-dialog-content class="w-full">
  <app-action-practice-form [data]="data"></app-action-practice-form>
</div>
